import { Box } from '@components/box'
import { Content } from '@components/layout/content'
import { Container } from '@components/layout/grid'
import { Text } from '@components/text'
import { PolicyCategory } from '@contentful-components/policy-category'
import { getOrCreateContentfulClient } from '@graphql/client'
import type { PageFragment } from '@graphql/fragments/PageFragment.graphql'
import type { PolicyCategoryFragment } from '@graphql/fragments/PolicyCategoryFragment.graphql'
import { getPolicies } from '@graphql/hooks/policies'
import { fetchContentfulPage } from '@lib/static/fetchStaticPage'
import { DEFAULT_PAGE_TTL } from '@lib/static/static-page'
import { PAGE_OPTIONS } from '@lib/utils/page'
import { categoryHasPolicies } from '@lib/utils/policy'
import { TEXT } from '@lib/utils/text'
import { PageTemplate } from '@page-templates/generic-page'
import type { NextPage } from 'next'

const Policies: NextPage<Props> = ({ page, categories }) => {
    // only display category if it has policies
    const filteredCategories = categories
        ?.filter(categoryHasPolicies)
        .map((category) => <PolicyCategory key={category.slug} {...category} />)

    return (
        <>
            <PageTemplate
                {...PAGE_OPTIONS.POLICIES}
                pageData={page}
                includeBody={false}
                includeBanner={false}
            />

            <Container>
                <Content>
                    <Box>
                        <Text
                            tag='h1'
                            typeStyle={{
                                _: 'heading-lg',
                                md: 'heading-2xl',
                            }}
                            bold
                        >
                            {TEXT.policies.pagetitle}
                        </Text>
                        <div>{filteredCategories}</div>
                    </Box>
                </Content>
            </Container>
        </>
    )
}

export default Policies

export const getStaticProps = async () => {
    const [page, categoryData] = await Promise.all([
        fetchContentfulPage(PAGE_OPTIONS.POLICIES.slug),
        getPolicies(getOrCreateContentfulClient('/policies')),
    ])

    const categories = categoryData?.data?.policyCategoryCollection?.items ?? []

    return { props: { page, categories }, revalidate: DEFAULT_PAGE_TTL }
}

interface Props {
    page: PageFragment
    categories: PolicyCategoryFragment[]
}
